module.exports = __webpack_public_path__ + "img/lg_ring_0_0_null_1@2x.b2d29251.png";